<template>
  <div class="base-modal" :class="`base-modal_${theme}`">
    <div class="base-modal_mask" v-if="showMask"></div>
    <div class="base-modal_cnt">
      <div v-if="showClose" class="base-modal_close" @click="handleClose"></div>
      <div class="base-modal_head-icon" v-if="headImgUrl"><img class="fit-img" :src="headImgUrl"></div>
      <div class="base-modal_main">
        <div class="base-modal_title">
          <slot name="title">{{title}}</slot>
        </div>
        <div class="base-modal_bd">
          <slot name="content">
            <div class="text">{{content}}</div>
            <div class="qrcode" v-if="qrcode">
              <img class="qrcode-img" :src="qrcode" alt="">
            </div>
          </slot>
        </div>
      </div>
      <div class="base-modal_ft" v-if="!hideFooter">
        <slot name="footer">
          <div class="base-modal_btn btn-cancel" v-if="cancelText" @click="handleCancel">{{cancelText}}</div>
          <div class="base-modal_btn btn-ok" @click="handleOk">{{okText}}</div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import headImage from '@/common/images/modal_headImage.png';

export default {
  name: 'BaseModal',
  props: {
    title: {
      type: String,
      default: '弹窗标题'
    },
    content: {
      type: String,
      default: ''
    },
    qrcode: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: '我知道啦'
    },
    cancelText: String,
    headImgUrl: {
      type: String,
      default: headImage,
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showMask: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: 'default' // default | blue
    },
  },
  methods: {
    handleOk() {
      this.$emit('ok');
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleClose() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="less" scoped>
.base-modal {
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &_mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(10, 17, 26, 0.5);;
    top: 0;
    left: 0;
  }
  &_cnt {
    min-width: 422px;
    min-height: 265px;
    background: #fff;
    border-radius: 20px;
    position: relative;
    padding: 30px 30px 36px;
    box-sizing: border-box;
  }
  &_main {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &_close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    background: url("@/common/images/ic_close2.png") center / contain no-repeat;
    cursor: pointer;
  }
  &_head-icon {
    width: 123px;
    height: 100px;
    margin: -72px auto 0;
  }
  &_title {
    font-size: 22px;
    font-weight: 600;
    color: #38475C;
    margin-bottom: 14px;
    margin-top: 12px;
  }
  &_bd {
    text-align: center;
    font-size: 18px;
    line-height: 22px;
    color: #38475C;
    .qrcode {
      box-sizing: border-box;
      background: #F0F5FC;
      border-radius: 24px;
      width: 160px;
      padding: 5px;
      margin: 0 auto;
      margin-top: 12px;
    }
    .qrcode-img {
      width: 100%;
      border-radius: 20px;
    }
  }
  &_ft {
    display: flex;
    width: 100%;
    margin-top: 34px;
    justify-content: center;
  }
  &_btn {
    cursor: pointer;
    width: 172px;
    background: #E60012;
    font-size: 18px;
    font-weight: 500;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    border-radius: 24px;
    &.btn-cancel {
      background: #F0F5FC;
      color: #3D5066;
    }
    &:nth-child(n+2) {
      margin-left: 18px;
    }
  }
  &.base-modal_blue {
    .base-modal_btn {
      background: #5B54FC;
      box-shadow: 0px 2px 4px -1px #2196F333;
      font-size: 16px;
      font-weight: 600;
      &.btn-cancel {
        color: #1D2129;
        box-shadow: none;
        background: #F2F3F5;
      }
    }
  }
}
</style>
